/**
 * Interface for the 'Clients' data
 */
export interface ClientsEntity {
  id: string | number; // Primary ID
  name: string;
}

export enum ClientsActionTypes {
  LoadPrimaryClient = '[Clients/Page] Load Primary Client',
  LoadPrimaryClientSuccess = '[Clients/API] Load Primary Client Success Old',
  LoadPrimaryClientFailure = '[Clients/API] Load Primary Client Failure',
  LoadClientSubClients = '[Clients/Page] Load Client Sub Clients',
  LoadClientSubClientsSuccess = '[Clients/API] Load Client Sub Clients Success Old',
  LoadClientSubClientsFailure = '[Clients/API] Load Client Sub Clients Failure Old',

  CheckLeadContact = '[Client/Page] Check Lead Contact',
  CheckLeadContactSuccess = '[Client/API] Check Lead Contact Success',
  CheckLeadContactFailure = '[Client/API] Check Lead Contact Failure',
}
